const dynamicPackage = {
  detailedPlan: "Detalusis planas", // translated 
  minimum: "Minimumas", // translated 
  maximum: "Maksimalus", // translated 
};


export default dynamicPackage;
